import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useMemo, useState } from 'react';
import { LibraryUploadStep } from '../../../context/MaterialPanelContext';
import { useRefCallback } from '@tencent/glue-react-use';
import { useVideoUpload } from '../../MaterialUpload/hooks/useVideoUpload';
import { useVideoList } from '../hooks/useVideoList';
import { RcMaterialPanel, useRcMaterialPanel } from '../RcMaterialPanel/RcMaterialPanel';
import { MaterialType } from '../UploadStatusModal/UploadStatusModal';
import { usePrefixCls } from '../../../../../config/hooks/usePrefixCls';
import { message } from '../../../../Message';
import { MaterialPanel } from '../PanelBase/PanelBase';
import { getPageSize } from '../../common/utils';
var VideoPanelImpl = function VideoPanelImpl(props) {
  var apiConfig = props.apiConfig,
    _props$listSizeConfig = props.listSizeConfig,
    listSizeConfig = _props$listSizeConfig === void 0 ? [] : _props$listSizeConfig,
    value = props.value,
    onChange = props.onChange,
    children = props.children,
    _props$panelStyleConf = props.panelStyleConfig,
    panelStyleConfig = _props$panelStyleConf === void 0 ? {
      panelWidth: 900,
      panelHeight: 514,
      panelCol: 3,
      panelRow: 5,
      panelItemWidth: 160
    } : _props$panelStyleConf;
  var _useRcMaterialPanel = useRcMaterialPanel(),
    step = _useRcMaterialPanel.step,
    setStep = _useRcMaterialPanel.setStep;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    activeImgId = _useState2[0],
    setActiveImgId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    name = _useState4[0],
    setName = _useState4[1];
  var onClose = useRefCallback(function () {
    abort();
    setStep(LibraryUploadStep.CLOSE);
    resetPanelState();
  });
  var _useVideoUpload = useVideoUpload({
      uploadConfig: {
        request: apiConfig.request,
        uid: apiConfig.uid,
        localUpload: apiConfig.videoUpload.localUpload,
        idUpload: apiConfig.videoUpload.idUpload
      },
      onClose: onClose,
      onCancel: onClose,
      value: value,
      onValueChange: onChange
    }),
    uploadIdFile = _useVideoUpload.uploadIdFile,
    uploadLocalFile = _useVideoUpload.uploadLocalFile;
  var uploadLocalFileClick = useRefCallback(function () {
    uploadLocalFile();
  });
  var resetPanelState = useRefCallback(function () {
    setName('');
    setActiveImgId('');
  });
  var _useVideoList = useVideoList({
      request: apiConfig.request,
      uid: apiConfig.uid,
      url: apiConfig.listUrl,
      conditionList: listSizeConfig,
      pageSize: getPageSize(panelStyleConfig)
    }),
    videoMap = _useVideoList.videoMap,
    pageInfo = _useVideoList.pageInfo,
    videoList = _useVideoList.videoList,
    getList = _useVideoList.getList,
    isLoading = _useVideoList.isLoading,
    abort = _useVideoList.abort;
  var onRefresh = useRefCallback(function () {
    getList({
      pageIndex: 1,
      name: name
    });
  });
  var queryChange = useRefCallback(function (val) {
    getList({
      pageIndex: 1,
      name: val
    });
    setName(val);
  });
  var panelOk = useRefCallback(function () {
    var urlVideoInfo = videoMap[activeImgId];
    if (!urlVideoInfo) {
      message.error('请选定素材');
      return;
    }
    var imageUrl = urlVideoInfo.imageUrl,
      width = urlVideoInfo.width,
      height = urlVideoInfo.height,
      fileName = urlVideoInfo.name,
      mediaId = urlVideoInfo.mediaId,
      size = urlVideoInfo.size;
    if (size > 100 * 1024 * 1024) {
      message.error('视频大小不得超过100M');
      return;
    }
    uploadIdFile({
      poster: imageUrl,
      mediaId: mediaId,
      width: width,
      height: height,
      name: fileName,
      size: size
    });
    resetPanelState();
    getList({
      pageIndex: 1,
      name: ''
    });
  });
  var listDts = useMemo(function () {
    return videoList.map(function (_ref) {
      var id = _ref.mediaId,
        width = _ref.width,
        height = _ref.height,
        size = _ref.size,
        fileName = _ref.name,
        url = _ref.imageUrl,
        duration = _ref.duration;
      return {
        id: id,
        url: url,
        width: width,
        height: height,
        size: size,
        name: fileName,
        duration: duration
      };
    });
  }, [videoList]);
  var onPageChange = useRefCallback(function (page) {
    getList({
      pageIndex: page,
      name: name
    });
  });
  var onUpload = useRefCallback(function () {
    setStep(LibraryUploadStep.LIBRARY_VIDEO_PANEL);
    getList({
      pageIndex: 1,
      name: ''
    });
  });
  var cls = usePrefixCls('material-library-panel');
  var materialHint = React.createElement(React.Fragment, null, "\u7B26\u5408\u5F53\u524D\u89C4\u683C\u8981\u6C42\u7684\u89C6\u9891\uFF0C\u5171", React.createElement("span", {
    className: "".concat(cls, "-bold")
  }, pageInfo.total), "\u4E2A\uFF0C\u4E0D\u652F\u63012021\u5E741\u6708\u524D\u4E0A\u4F20\u7684\u7D20\u6750");
  var headerOps = {
    onRefresh: onRefresh,
    uploadLocalFile: uploadLocalFileClick,
    materialHint: materialHint,
    searchValue: name,
    onSearchValueChange: queryChange
  };
  var listOps = {
    dts: listDts,
    activeId: activeImgId,
    setActiveId: setActiveImgId,
    total: pageInfo.total,
    currentPage: pageInfo.pageIndex,
    onPageChange: onPageChange
  };
  var triggerNode = children && React.createElement("div", {
    className: "".concat(cls, "-upload-trigger"),
    onClick: onUpload
  }, children);
  return React.createElement(MaterialPanel, {
    isLoading: isLoading,
    show: step === LibraryUploadStep.LIBRARY_VIDEO_PANEL,
    panelStyleConfig: panelStyleConfig,
    onOk: panelOk,
    onCancel: onClose,
    headerOps: headerOps,
    listOps: listOps,
    materialType: MaterialType.VIDEO
  }, triggerNode);
};
export var VideoPanel = function VideoPanel(props) {
  return React.createElement(RcMaterialPanel, null, React.createElement(VideoPanelImpl, _objectSpread({}, props)));
};